import s,{Component as f}from"react";import r from"prop-types";import{mergeStyles as k,validate as V,containsUrl as b,normalizeUrl as z,GlobalContext as q}from"wix-rich-content-common";import _ from"wix-rich-content-common/dist/statics/schemas/plugin-html.schema.json";const v="html",y="url",w=350,I=550;var N=`
  <head>
    <style type="text/css">
      iframe[class|='instagram'],
      blockquote[class|='instagram'] {
        /* fallback script for ios below */
        min-width: 0 !important;
        width: calc(100vw - 2px);
      }

      body {
        margin: 0;
        max-width: calc(100vw);
        display: inline-block;
        float: left;
        width: 100%;
        box-sizing: border-box;
      }
      body > iframe {
        margin: 0 !important;
        width: calc(100vw - 2px) !important;
      }
      body::before,
      body::after {
        content: '.';
        height: 0;
        margin: 0;
        overflow: hidden;
        visibility: hidden;
        display: block;
        clear: both;
      }
    </style>
    <script>
      (function fixInstagramWidth() {
        // This is a fallback for the styles above. Because inline styles can't be overridden in ios.
        var callback = function() {
          try {
            if (document.body.firstChild.className.indexOf('instagram') >= 0) {
              document.body.firstChild.style.minWidth = '0';
              document.body.firstChild.style.width = 'calc(100vw - 2px)';
            }
          } catch (e) {}
        };

        var observer = new MutationObserver(callback);

        observer.observe(document, {
          childList: true,
          subtree: true,
        });
      })();

      function initSendHeight(id) {
        /**
         * Handle image load by triggering a resize
         */
        function imageLoaded(event) {
          if (!event || event.type !== 'load') {
            return;
          }

          var img = event.srcElement;
          // Remove image from loading stack
          var imageIndex = images.indexOf(img);
          if (imageIndex !== -1) {
            images.splice(imageIndex, 1);
          }

          handleResize();
        }

        /**
         * Add 'load' event listener and store reference to image
         * @param {elm} img Image being loaded
         */
        var images = [];
        function addImage(img) {
          if (images.indexOf(img) === -1) {
            img.addEventListener('load', imageLoaded);
            images.push(img);
          }
        }

        /**
         * Filter out images in the DOM that haven't loaded yet and add listener
         */
        function addImageLoadListeners() {
          var imgs = document.querySelectorAll('img');
          for (var i = 0; i < imgs.length; i++) {
            var image = imgs[i];
            // Do nothing if image is already loaded
            if (
              image.nodeName === 'IMG' &&
              image.src &&
              image.complete === false &&
              image.readyState !== 4
            ) {
              addImage(image);
            }
          }
        }

        function getHeight() {
          var height = parseInt(document.body.offsetHeight, 10);
          var styles = document.defaultView.getComputedStyle(document.body);
          height += parseInt(styles.getPropertyValue('margin-bottom'), 10);
          height += parseInt(styles.getPropertyValue('margin-top'), 10);
          return height;
        }

        function handleResize() {
          multipleDelayedSendHeight();
        }

        var timerId;
        function multipleDelayedSendHeight() {
          sendHeight();
          clearTimeout(timerId);
          let delay = 100;
          timerId = setTimeout(function request() {
            sendHeight();
            delay *= 2;
            if (delay < 20000) {
              timerId = setTimeout(request, delay);
            }
          }, delay);
        }

        function sendHeight() {
          var height = getHeight();
          parent.postMessage({ type: 'htmlPlugin:heightResize', id: id, height: height }, '*');
        }

        function setupMutationObserver() {
          var target = document.querySelector('body');
          var observer = new MutationObserver(function(mutations) {
            addImageLoadListeners();
            handleResize();
          });

          var config = {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true,
          };

          observer.observe(target, config);
        }

        window.addEventListener('resize', handleResize); //this handles width change
        setupMutationObserver();
        handleResize();
      }

      window.addEventListener('message', function(event) {
        if (event.data.type !== 'htmlPlugin:updateContent') {
          return;
        }

        var content = [
          '<!DOCTYPE html>',
          '<html>',
          '<head>' + document.head.innerHTML + '</head>',
          '<body>' + event.data.content + '</body>',
          '</html>',
        ].join('');

        document.open('text/html', 'replace');
        document.write(content);
        document.close();
        initSendHeight(event.data.id);
      });
    <\/script>
  </head>

  <body></body>
`,W={iframe:"D-FLw"},F=Object.defineProperty,d=Object.getOwnPropertySymbols,x=Object.prototype.hasOwnProperty,H=Object.prototype.propertyIsEnumerable,O=(i,e,t)=>e in i?F(i,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):i[e]=t,U=(i,e)=>{for(var t in e||(e={}))x.call(e,t)&&O(i,t,e[t]);if(d)for(var t of d(e))H.call(e,t)&&O(i,t,e[t]);return i},B=(i,e)=>{var t={};for(var a in i)x.call(i,a)&&e.indexOf(a)<0&&(t[a]=i[a]);if(i!=null&&d)for(var a of d(i))e.indexOf(a)<0&&H.call(i,a)&&(t[a]=i[a]);return t};const D=i=>{var e=i,{iframeRef:t,isViewer:a}=e,n=B(e,["iframeRef","isViewer"]);return s.createElement("iframe",U({ref:t,className:W.iframe,title:"remote content",style:{backgroundColor:"transparent"},allow:a?"fullscreen; autoplay":"fullscreen",allowFullScreen:!0},n))};var G=Object.defineProperty,S=Object.getOwnPropertySymbols,Y=Object.prototype.hasOwnProperty,A=Object.prototype.propertyIsEnumerable,c=(i,e,t)=>e in i?G(i,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):i[e]=t,Q=(i,e)=>{for(var t in e||(e={}))Y.call(e,t)&&c(i,t,e[t]);if(S)for(var t of S(e))A.call(e,t)&&c(i,t,e[t]);return i},m=(i,e,t)=>(c(i,typeof e!="symbol"?e+"":e,t),t);const R=typeof window=="undefined",J="/html/db9376e69cfa487ea0fa0b912ae51a4f_v1.html";class C extends f{constructor(){super(...arguments),m(this,"state",{shouldRender:!1}),m(this,"id",Math.random().toString(36).substr(2,9)),m(this,"updateIframeContent",e=>{var t;this.shouldIgnoreLoad=!0,(t=this.iframe)==null||t.contentWindow.postMessage({type:"htmlPlugin:updateContent",id:this.id,content:e},"*")}),m(this,"handleIframeMessage",({data:e})=>{const{type:t,id:a,height:n}=e;t==="htmlPlugin:heightResize"&&a===this.id&&this.props.onHeightChange(n)}),m(this,"handleIframeLoad",()=>{!this.shouldIgnoreLoad&&this.updateIframeContent(this.props.html)})}componentDidMount(){this.setState({shouldRender:!0}),!R&&window.addEventListener("message",this.handleIframeMessage)}componentWillUnmount(){!R&&window.removeEventListener("message",this.handleIframeMessage)}componentWillReceiveProps(e){this.props.html!==e.html&&this.updateIframeContent(e.html)}render(){const{iframeSandboxDomain:e,isViewer:t}=this.props,a={style:{backgroundColor:"transparent"},onLoad:this.handleIframeLoad,iframeRef:n=>this.iframe=n,isViewer:t};if(e){const n=e.replace(/\/$/,"");a.src=n+J}else a.srcdoc=N;return this.state.shouldRender?s.createElement(D,Q({},a)):null}}C.propTypes={html:r.string.isRequired,onHeightChange:r.any,iframeSandboxDomain:r.string,isViewer:r.bool};var K=C,X=Object.defineProperty,Z=Object.defineProperties,ee=Object.getOwnPropertyDescriptors,L=Object.getOwnPropertySymbols,te=Object.prototype.hasOwnProperty,ie=Object.prototype.propertyIsEnumerable,P=(i,e,t)=>e in i?X(i,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):i[e]=t,ae=(i,e)=>{for(var t in e||(e={}))te.call(e,t)&&P(i,t,e[t]);if(L)for(var t of L(e))ie.call(e,t)&&P(i,t,e[t]);return i},re=(i,e)=>Z(i,ee(e));const ne=i=>s.createElement(D,re(ae({},i),{sandbox:"allow-popups allow-presentation allow-forms allow-same-origin allow-scripts"}));var oe={htmlComponent:"_9lBLQ",htmlComponent_placeholder:"eVgIb"};const se=(i,e)=>{const t=i==null?void 0:i.includes("adsbygoogle"),a=i==null?void 0:i.includes("data-page-url=");if(e&&t&&!a){const n=`<ins class="adsbygoogle"
	data-page-url="${e}"`;return i==null?void 0:i.replace(new RegExp('<ins class="adsbygoogle"',"g"),n)}return i};var le=Object.defineProperty,me=(i,e,t)=>e in i?le(i,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):i[e]=t,h=(i,e,t)=>(me(i,typeof e!="symbol"?e+"":e,t),t);const de=i=>{if(!i)return;const e=/http.+com/gm.exec(i);return e&&e[0]};class g extends f{constructor(){super(...arguments),h(this,"state",{siteDomain:void 0}),h(this,"setHeight",e=>{var t;e>0&&e!==this.state.iframeHeight&&(this.setState({iframeHeight:e}),(t=this.props.store)==null||t.update("componentData",{config:{height:e}}))}),h(this,"getIframeHeight",()=>{const{settings:{height:e}={},componentData:{config:t}}=this.props,{iframeHeight:a}=this.state,n=Math.min(50,this.state.iframeHeight*.1);let o=a;return t.height&&(o=a&&t.height<a&&t.height+n>a?a:t.height),o||e||I})}componentDidMount(){const{componentData:{config:e},settings:t={}}=this.props,{width:a,height:n,siteDomain:o}=t;e.width||(a?e.width=a:this.element?e.width=this.element.getBoundingClientRect().width:e.width=w),e.height||(e.height=n||I),this.setState({siteDomain:o})}static getDerivedStateFromProps(e,t){const{componentData:a}=e;if(a.srcType==="html"){const n=de(t.siteDomain);return{html:se(a.src,n)}}}render(){var e;const{html:t}=this.state,{iframeSandboxDomain:a,theme:n,componentData:o,settings:{width:j}={},isViewer:p}=this.props;this.styles=this.styles||k({styles:oe,theme:n}),V(o,_);const{src:l,srcType:u,config:{width:E}={}}=o,$={width:this.props.isMobile?"auto":E||j||w,height:this.getIframeHeight(),maxHeight:this.state.iframeHeight},M=this.props.experiments||this.context.experiments;return s.createElement("div",{className:this.styles.htmlComponent,ref:T=>this.element=T,style:$,"data-hook":"HtmlComponent"},u===v&&l&&s.createElement(K,{iframeSandboxDomain:a||((e=M.forceIframeSandboxDomain)==null?void 0:e.enabled)&&"https://www.filesusr.com",key:v,tabIndex:0,html:t,onHeightChange:this.setHeight,isViewer:p}),u===y&&b(l)&&s.createElement(ne,{key:y,tabIndex:0,src:z(l),isViewer:p}),!l&&!b(l)&&s.createElement("div",{className:this.styles.htmlComponent_placeholder}))}}h(g,"contextType",q),g.propTypes={componentData:r.object.isRequired,blockProps:r.object,className:r.string,settings:r.shape({width:r.number,minWidth:r.number,maxWidth:r.number,height:r.number,minHeight:r.number,maxHeight:r.number}).isRequired,store:r.object,block:r.object,siteDomain:r.string,theme:r.object.isRequired,isMobile:r.bool.isRequired,iframeSandboxDomain:r.string,experiments:r.object,isViewer:r.bool};var he=g;export{he as default};

import 'wix-rich-content-plugin-html/dist/lib/styles.HtmlComponent.min.global.css'